export function getGroundClass(groundGroup?: string): string {
  if (!groundGroup) {
    return '';
  }

  switch (groundGroup.toUpperCase()) {
    case 'STOCK':
      return 'green';
    case 'DOCK':
      return 'light-blue';
    case 'EXPEDITION':
      return 'teal';
    case 'QUALITY_CONTROL':
      return 'purple';
    case 'DIVERGENT_STOCK':
      return 'red';
    case 'STREET':
      return 'gray';
    case 'DAMAGES':
      return 'yellow';
    case 'PICKING':
      return 'pink';
    case 'PROVISION':
      return 'light-green';
    case 'IN':
      return 'orange';
    case 'EXIT':
      return 'black';
    case 'PICKING_MISCELLANEOUS':
      return 'picking-miscellaneous';
    default:
      return 'default';
  }
}
